import axios from 'axios';
import appHelpers from '../utils/app-urls';

const cdnURL = appHelpers.getCDNUrl();

const cdnApi = axios.create({
  baseURL: cdnURL,
});

export default cdnApi;
